import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { EditAreaLightingComponent } from '../edit-area-lighting/edit-area-lighting.component';

@Component({
  selector: 'app-delete-area-lighting',
  templateUrl: './delete-area-lighting.component.html',
  styleUrls: ['./delete-area-lighting.component.scss']
})
export class DeleteAreaLightingComponent implements OnInit {
  lightingId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditAreaLightingComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _runwayService: RunwayService) {
    this.lightingId = data.lightingId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._runwayService.deleteLighting(this.airportId, this.lightingId);
      this.isLoading = false;
      this.close({success: true, lightingId: this.lightingId});
    } catch (e) {
      this.close({success: false, error: e});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
